import clientAxios from './../../config/axios';
import { Housekey } from './models/Housekey';

export const getAllHousekeys = async (
  { filter, pagination }: any,
  token: string
) => {
  const filterTmp = filter ?? '';
  const complement = pagination.page
    ? `page=${pagination.page}&items_per_page=${pagination.rowsPerPage}${filterTmp}`
    : `all=1${filterTmp}`;
  const url = `/keys?country=${process.env.REACT_APP_ENV_COUNTRY}&${complement}`;
  const { data } = await clientAxios.get(url, {
    headers: { Authorization: `Bearer ${token}` },
  });
  data.keys = data.keys.map((key: Housekey) => {
    if (key.loan) {
      key.loan.created = new Date(key.loan.created);
      key.loan.end_date = new Date(key.loan.end_date);
    }
    return key;
  });
  return data;
};

export const updateHousekey = (housekey: any, token: string) => {
  const url = `/keys?country=${process.env.REACT_APP_ENV_COUNTRY}&id=${housekey.id}`;
  return clientAxios.put(url, housekey, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const createHousekey = (housekey: any, token: string) => {
  const url = `/keys`;
  return clientAxios.post(url, housekey, {
    headers: { Authorization: `Bearer ${token}` },
  });
};
